module.exports = __webpack_public_path__ + "static/img/companyProducts6.bdf8447c.png";